import shouldTableSortByRenewTime from './shouldTableSortByRenewTime';
import { listViewStore, } from 'owa-mail-list-store';
import { trace } from 'owa-trace';
import { select } from 'satcheljs/lib/legacy';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import { mailStore } from 'owa-mail-store';
export function isRowSortKeyEqual(row, tableView) {
    var isSortKeyEqual = false;
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            isSortKeyEqual = isConversationSortKeyEqual(tableView.tableQuery, getTableConversationRelation(row.InstanceKey, tableView.id), row);
            break;
        case 1 /* Message */:
            isSortKeyEqual = isItemSortKeyEqual(tableView.tableQuery, row, mailStore.items.get(row.ItemId.Id));
            break;
    }
    return isSortKeyEqual;
}
export var isConversationSortKeyEqual = select({
    listViewStore: function () { return listViewStore; },
})(function isConversationSortKeyEqual(tableQuery, tableConversationRelation, conversation, state) {
    if (!(tableQuery.type == 0 /* Folder */ || tableQuery.type == 2 /* Group */)) {
        trace.error('isConversationSortKeyEqual should not be called on non MailFolderTableQuery type');
        return false;
    }
    var sortBy = tableQuery.sortBy;
    if (!sortBy) {
        throw new Error('SortBy should not be null');
    }
    var isInstanceKeyEqual = tableConversationRelation.instanceKey == conversation.InstanceKey;
    var isDateTimeEqual = areConversationsDateTimeEqual(tableQuery, tableConversationRelation, conversation);
    if (!isInstanceKeyEqual || !isDateTimeEqual) {
        // if instanceKey or dateTime are not equal, return false
        return false;
    }
    switch (sortBy.sortColumn) {
        case 0 /* Date */:
        case 1 /* From */: // From can only change in drafts but drafts will always be a message view
            return true;
        case 2 /* Size */:
            var conversationItem = state.listViewStore.conversationItems.get(tableConversationRelation.id);
            return conversationItem.size == conversation.Size;
        default:
            trace.warn('isSortKeyEqual: sortColumn not supported ' + sortBy.sortColumn);
            return false;
    }
});
export function isItemSortKeyEqual(tableQuery, itemTarget, itemReference) {
    if (!(tableQuery.type == 0 /* Folder */ || tableQuery.type == 2 /* Group */)) {
        trace.error('isItemSortKeyEqual should not be called on non MailFolderTableQuery type');
        return false;
    }
    var sortBy = tableQuery.sortBy;
    if (!sortBy) {
        throw new Error('SortBy should not be null');
    }
    var isInstanceKeyEqual = itemTarget.InstanceKey == itemReference.InstanceKey;
    var isDateTimeEqual = areItemsDateTimeEqual(tableQuery, itemTarget, itemReference);
    if (!isInstanceKeyEqual || !isDateTimeEqual) {
        // if instanceKey or dateTime are not equal, return false
        return false;
    }
    switch (sortBy.sortColumn) {
        case 0 /* Date */: // Compare date time sortKey
            return true;
        case 1 /* From */:
            var itemTargetMessage = getItemAsMessage(itemTarget);
            var itemReferenceMessage = getItemAsMessage(itemReference);
            if (itemTargetMessage && itemReferenceMessage) {
                var itemTargetEmailAddress = itemTargetMessage.From && itemTargetMessage.From.Mailbox.EmailAddress;
                var itemReferenceEmailAddress = itemReferenceMessage.From && itemReferenceMessage.From.Mailbox.EmailAddress;
                return itemTargetEmailAddress == itemReferenceEmailAddress;
            }
            else {
                // it won't be the case that one is a message and other is not as the instance keys have already matched
                // so we return true for other item types
                return true;
            }
        case 2 /* Size */: // Size can change in case of drafts
            return itemTarget.Size == itemReference.Size;
        default:
            trace.warn('isSortKeyEqual: sortColumn not supported ' + sortBy.sortColumn);
            return false;
    }
}
function getItemAsMessage(item) {
    if (item.ItemClass.indexOf('IPM.Schedule.Meeting') !== -1 ||
        item.ItemClass.indexOf('IPM.Note') !== -1) {
        return item;
    }
    return null;
}
function areItemsDateTimeEqual(tableQuery, itemTarget, itemReference) {
    // Note: we need to convert the timestamp into date objects for comparison
    // because we've seen issues where the server may return the time in UTC format.
    // We should be resilient on the client against such issues.
    if (shouldTableSortByRenewTime(tableQuery)) {
        return (new Date(itemTarget.ReceivedOrRenewTime).getTime() ==
            new Date(itemReference.ReceivedOrRenewTime).getTime());
    }
    else {
        return (new Date(itemTarget.DateTimeReceived).getTime() ==
            new Date(itemReference.DateTimeReceived).getTime());
    }
}
function areConversationsDateTimeEqual(tableQuery, tableConversationRelation, conversation) {
    // Note: we need to convert the timestamp into date objects for comparison
    // because we've seen issues where the server may return the time in UTC format.
    // We should be resilient on the client against such issues.
    if (shouldTableSortByRenewTime(tableQuery)) {
        return (new Date(tableConversationRelation.lastDeliveryOrRenewTimeStamp).getTime() ==
            new Date(conversation.LastDeliveryOrRenewTime).getTime());
    }
    else {
        return (new Date(tableConversationRelation.lastDeliveryTimeStamp).getTime() ==
            new Date(conversation.LastDeliveryTime).getTime());
    }
}
//# sourceMappingURL=isSortKeyEqual.js.map